import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { MovieCatalogItem } from '@/types/movie-catalog';
import { MoviesListGridItem } from './movies-list-grid-item';

type MoviesListGridProps = {
  movies: MovieCatalogItem[];
  tabLabel: string;
  zipCode?: string;
};

export const MoviesListGrid = ({ movies, tabLabel, zipCode }: Readonly<MoviesListGridProps>): React.JSX.Element => {
  return (
    <div className="grid grid-cols-2 gap-md md:grid-cols-3 ml:grid-cols-4 lg:grid-cols-5"
      data-test="movies-poster-grid"
    >
      {movies.map((movie, index) =>
        <MoviesListGridItem key={`${movie.movieId}-${index}`}
          dataLinkCategory={AnalyticsPageCategories.MOVIES_PAGE}
          index={index}
          movie={movie}
          tabLabel={tabLabel}
          zipCode={zipCode}
        />
      )}
    </div>
  );
};
